import { taskApiClient } from '@/utils/apiClient';

/**
 * Billing service — proxied through the gateway to the task management backend
 */
export const getAllRequests = async () => {
  const res = await taskApiClient.get('/billing/requests');
  return res.data;
};

export const getInvoiceByRequest = async (requestId: string) => {
  const res = await taskApiClient.get(`/billing/requests/${requestId}/invoice`);
  return res.data;
};

export const approveEnterpriseRequest = async (requestId: string) => {
  const res = await taskApiClient.post(`/billing/requests/${requestId}/approve`);
  return res.data;
};

export const rejectEnterpriseRequest = async (requestId: string, remarks: string) => {
  const res = await taskApiClient.post(`/billing/requests/${requestId}/reject`, { remarks });
  return res.data;
};

export const getPaymentByInvoiceId = async (invoiceId: string) => {
  const res = await taskApiClient.get(`/billing/invoices/${invoiceId}/payment`);
  return res.data;
};

export const verifyPayment = async (paymentId: string, data: { remarks: string; verifiedBy: string }) => {
  const res = await taskApiClient.post(`/billing/payments/${paymentId}/verify`, data);
  return res.data;
};
